import '../sass/Global.scss'
import Banner from './Banner'
import Name from './Name'
import Profil from './Profil'
import Projects from './Projects'
import Skills from './Skills'
import Timeline from './Timeline'
import Download from './Download'
import Contact from './Contact'

function App() {
	return (
		<section>
			<Banner />
			<main className='for-max-width'>
			<Name />
			<Profil />
			<Projects />
			<Skills />
			<Timeline />
			<Download />
			<Contact />
			</main>
		</section>
	)
}

export default App